/** Served from `public/brand/` (synced from web-admin + mobile assets). */
export const brand = {
  wordmark: '/brand/logo-wordmark.png',
  combo: '/brand/logo-combo.png',
  icon: '/brand/logo-icon.png',
  /** Full wordmark + icon treatment from mobile marketing asset */
  shmatchBrand: '/brand/shmatch-brand.png',
} as const;
